var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import SectorButton from '../projects/SectorButton.vue';
import ArticleInfo from '../articles/ArticleInfo.vue';
import Pager from '../shared/Pager.vue';
import Loader from '../shared/Loader.vue';
import SocialLink from '../shared/SocialLink.vue';
import StoryPathCard from './StoryPathCard.vue';
import Choices from 'choices.js';
const service = namespace('Service');
let StoryPathsList = class StoryPathsList extends Vue {
    constructor() {
        super(...arguments);
        this.loading = true;
        this.noResult = false;
        this.data = [];
        this.pageLoading = false;
        this.activeSectorId = 0;
        this.currentPage = new URLSearchParams(window.location.search).get('page')
            ? Number(new URLSearchParams(window.location.search).get('page'))
            : 1;
        this.numberOfPage = 0;
        this.itemPerPage = 60;
        this.args = {};
        this.filterSelect = null;
        this.selectProps = {
            searchEnabled: false,
            shouldSort: false,
            placeholder: true,
            placeholderValue: '',
            itemSelectText: ''
        };
    }
    created() {
        const url = new URL(window.location.href);
        const querySectorId = new URLSearchParams(window.location.search).get('sectorId');
        const page = new URLSearchParams(window.location.search).get('page');
        if (this.activeSector) {
            this.activeSectorId = this.activeSector.id;
        }
        if (querySectorId) {
            this.activeSectorId = Number(querySectorId);
        }
        url.searchParams.set('sectorId', String(this.activeSectorId));
        url.searchParams.set('page', String(this.currentPage));
        window.history.replaceState({}, '', url);
        this.args = {
            siteId: window.cibbic.siteId,
            relatedToCategories: this.activeSectorId ? [this.activeSectorId] : null,
            offset: page ? (Number(page) - 1) * this.itemPerPage : 0
        };
        this.getStoryPaths(this.args);
        if (this.activeSector) {
            this.activeSectorId = this.activeSector.id;
        }
    }
    mounted() {
        this.selectProps.noResultsText = this.labels.noResultsText;
        this.selectProps.noChoicesText = this.labels.noChoicesText;
        this.filterSelect = new Choices('#sectorFilter', Object.assign(Object.assign({}, this.selectProps), { labelId: 'sectorFilterLabel' }));
        if (this.storyPathSectors.length > 0) {
            this.fillSectorsDropDown();
        }
        this.pageLoading = true;
    }
    onSectorClicked(sector) {
        this.pageLoading = true;
        this.activeSectorId = sector ? sector.id : 0;
        this.currentPage = 1;
        const url = new URL(window.location.href);
        url.searchParams.set('sectorId', String(this.activeSectorId));
        url.searchParams.set('page', String(this.currentPage));
        window.history.replaceState({}, '', url);
        this.args = {
            siteId: window.cibbic.siteId,
            relatedToCategories: this.activeSectorId ? [this.activeSectorId] : null,
            offset: 0
        };
        this.getStoryPaths(this.args);
    }
    onPageChange(value) {
        this.pageLoading = true;
        this.currentPage = value;
        this.args.offset = (value - 1) * this.itemPerPage;
        this.getStoryPaths(this.args);
    }
    onSectorFilterChanged(evt) {
        if (evt.detail.value === 0) {
            this.onSectorClicked(null);
        }
        else {
            let sector = this.storyPathSectors.find((s) => {
                return s.id === evt.detail.value;
            });
            this.onSectorClicked(sector);
        }
    }
    fillSectorsDropDown() {
        var _a;
        let tmp = this.storyPathSectors.map((i) => {
            return { value: i.id, label: i.title, selected: this.activeSectorId == i.id };
        });
        tmp.unshift({ value: 0, label: this.labels.all_sectors, selected: this.activeSectorId === 0 });
        (_a = this.filterSelect) === null || _a === void 0 ? void 0 : _a.setChoices(tmp, 'value', 'label', true);
    }
    onArticlesData(value) {
        this.noResult = false;
        this.data = this.articlesData.articles || [];
        if (this.data.length > 0) {
            this.numberOfPage = Math.ceil(this.itemCount / this.itemPerPage);
            setTimeout(() => {
                this.pageLoading = false;
                window.cibbic.lazyLoadInstance.update();
            }, 100);
            if (window.scrollY > 0) {
                document.querySelector('#story-paths-list-component').scrollIntoView({
                    behavior: 'smooth'
                });
            }
        }
        else if (this.data.length === 0 && this.articlesData.articles !== undefined) {
            this.pageLoading = false;
            this.noResult = true;
        }
    }
    onSectors() {
        this.fillSectorsDropDown();
        this.loading = false;
    }
};
__decorate([
    Prop({ type: Object })
], StoryPathsList.prototype, "labels", void 0);
__decorate([
    Prop({ type: Object })
], StoryPathsList.prototype, "activeSector", void 0);
__decorate([
    Prop({ default: true })
], StoryPathsList.prototype, "showPagination", void 0);
__decorate([
    service.State
], StoryPathsList.prototype, "articlesData", void 0);
__decorate([
    service.State
], StoryPathsList.prototype, "itemCount", void 0);
__decorate([
    service.State
], StoryPathsList.prototype, "storyPathSectors", void 0);
__decorate([
    service.Action
], StoryPathsList.prototype, "getStoryPaths", void 0);
__decorate([
    Watch('articlesData')
], StoryPathsList.prototype, "onArticlesData", null);
__decorate([
    Watch('storyPathSectors')
], StoryPathsList.prototype, "onSectors", null);
StoryPathsList = __decorate([
    Component({
        components: {
            SectorButton,
            ArticleInfo,
            Pager,
            Loader,
            SocialLink,
            StoryPathCard
        }
    })
], StoryPathsList);
export default StoryPathsList;
